import {API, API_PAYMENT} from "../../Services";


async function StoreOnlineCoupons(merchantId){
    let token =  localStorage.getItem('token');
    return API.get(`/users/coupons?is_valid=true&merchant_uid=${merchantId}`,{headers: { 'Authorization':  `Bearer ${token}`}});
}
async function StoreOnlineAddCoupons(merchantId,obj){
    let token =  localStorage.getItem('token');
    return API.post(`/users/coupons?merchant_uid=${merchantId}`,obj,{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function StoreOnlineFinal(mId){
    let token =  localStorage.getItem('token');
    return API.post(`/shop/cart/finalize/`,{},{
        params:{
            merchant:mId
        },
        headers: { 'Authorization':  `Bearer ${token}`}});
}

// async function StoreOnlineFinalCoupon(id,invoiceId){
//     let token =  localStorage.getItem('token');
//     return API.post(`/shop/cart/finalize/`,{
//         coupon_code:id
//     },{headers: { 'Authorization':  `Bearer ${token}`}});
// }


async function StoreOnlineFinalCoupon(id,invoiceId){
    let token =  localStorage.getItem('token');
    return API.post(`/shop/cart/finalize_coupon/`,{
        coupon_code: id,
        invoice_uid: invoiceId,
    },{headers: { 'Authorization':  `Bearer ${token}`}});
}


async function StoreOnlineCreateInvoice(obj){
    let token =  localStorage.getItem('token');
    //return API_PAYMENT.post(`/client/invoices/create/`,obj,{
    return API.post(`/gateway/create/invoices/`,obj,{
        headers: {
            'Authorization':  `Bearer ${token}`,
            'client-id':  'c7d152dff5344207b6502a5fc3085ce9',
        }
    });
}

async function StoreOnlineGateWay(name,sign){
    let token =  localStorage.getItem('token');
    //return API_PAYMENT.post(`/invoice/${sign}/pay/gateway/${name}/`,{},{
    return API.post(`/gateway/${sign}/pay/gateway/${name}/`,{},{
        headers: {
            'Authorization':  `Bearer ${token}`,
            'client-id':  'c7d152dff5344207b6502a5fc3085ce9',
        }
    });
}


async function changePaymentType(id,type){
    let token =  localStorage.getItem('token');
    return API.put(`/payments/invoices/${id}/set-payment-method`,{
        "payment_method": type
    },{
        headers: {
            'Authorization':  `Bearer ${token}`
        }
    });
}

async function StoreOnlinePaymentVerify(id,sign){
    let token =  localStorage.getItem('token');
    return API.post(`/payments/invoices/${id}/verification`,{
        purchase_token: sign
    },{
        headers: {
            'Authorization':  `Bearer ${token}`
        }
    });
}




export {
    StoreOnlineCoupons,
    StoreOnlineFinal,
    StoreOnlineCreateInvoice,
    StoreOnlineAddCoupons,
    StoreOnlineGateWay,
    StoreOnlinePaymentVerify,
    changePaymentType,
    StoreOnlineFinalCoupon
}
